export default __webpack_public_path__ + "static/sponsor-logo-holo-475fcf6200e6efa573fc43edeb15f113.png";